export default __webpack_public_path__ + "static/giffey-806b6bdb987b85db8949e019845d31d5.webp";